export enum TaskInterestStatus {
  Unanswered = 0,
  Interested = 1,
  NotInterested = 2,
}
